// components/AmbassadorTrack/AmbassadorTrackList.js

import React from "react";

const AmbassadorTrackList = ({ data = [], onHistory }) => {
  return (
    <div className="premium-user-list-wrapper">
      <div className="premium-scroll-container">
        {data?.map((item, index) => {
          const completion = item.achievementCompletion || 0;
          const isCompleted = completion >= 100;
          
          // ✅ Show active status if user has any active KPI
          const isActive = item.active > 0;
          
          // ✅ Show if user has any expired KPI
          const hasExpired = item.expired > 0;
          
          // ✅ Show if user has any completed KPI
          const hasCompleted = item.completed > 0;

          return (
            <div key={item.userId || index} className="premium-table-row">
              {/* USER */}
              <div style={{ width: "25%" }} className="plan-cell">
                <div className="plan-info">
                  <div className="user-box">
                    <img
                      src={item.profileImageURL || "/default-avatar.png"}
                      alt="user"
                      className="user-avatar"
                    />
                    <div>
                      <div className="plan-title">
                        {item.name || "Unknown User"}
                      </div>
                      <div className="plan-desc">
                        {item.email || "No email"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ACTIVITY */}
              <div style={{ width: "20%" }} className="plan-desc">
                <div>📍 {item.totalCheckins || 0} Check-ins</div>
                <div>📸 {item.totalUploads || 0} Uploads</div>
                <div>👥 {item.totalReferrals || 0} Referrals</div>
              </div>

              {/* GOAL STATUS */}
              <div style={{ width: "20%" }}>
                {item.totalAchievements > 0 ? (
                  <>
                    <div className="goal-progress">
                      <div className="goal-label">
                        Achievements: {item.completedAchievements || 0}/{item.totalAchievements || 0}
                      </div>
                      <div className="progress-bar">
                        <div 
                          className={`progress-fill ${isCompleted ? 'completed' : ''}`}
                          style={{ width: `${Math.min(completion, 100)}%` }}
                        />
                      </div>
                    </div>
                    <div className="plan-desc" style={{ fontSize: "11px", marginTop: "4px" }}>
                      {completion}% Complete
                    </div>
                  </>
                ) : (
                  <span className="no-data">No achievements</span>
                )}
              </div>

              {/* COMPLETION */}
              <div style={{ width: "20%" }}>
                <span className={`completion-badge ${completion >= 100 ? 'complete' : 'progress'}`}>
                  {completion >= 100 ? '✅ Complete' : `${completion}%`}
                </span>
              </div>

              {/* STATUS */}
              <div style={{ width: "15%" }}>
                {isActive ? (
                  <span className="status-badge active">🟢 Active</span>
                ) : hasExpired ? (
                  <span className="status-badge expired">🔴 Expired</span>
                ) : hasCompleted ? (
                  <span className="status-badge completed">✅ Completed</span>
                ) : (
                  <span className="status-badge inactive">⚪ Inactive</span>
                )}
                <div style={{ fontSize: "10px", color: "#94a3b8", marginTop: "4px" }}>
                  {item.totalCycles || 0} Cycles
                </div>
                {/* ✅ Show breakdown */}
                <div style={{ fontSize: "9px", color: "#94a3b8", marginTop: "2px" }}>
                  {item.active > 0 && <span>🟢 {item.active} active</span>}
                  {item.expired > 0 && <span> 🔴 {item.expired} expired</span>}
                  {item.completed > 0 && <span> ✅ {item.completed} completed</span>}
                </div>
              </div>

              {/* ACTION */}
              <div style={{ width: "15%" }}>
                <button
                  className="history-btn"
                  onClick={() => onHistory(item)}
                >
                  📋 History
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <style>{`
        .premium-table-row {
          display: flex;
          padding: 18px 16px;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          align-items: center;
        }

        .premium-table-row:hover {
          background: rgba(255,255,255,0.02);
        }

        .plan-title {
          color: #fff;
          font-weight: 600;
          font-size: 14px;
        }

        .plan-desc {
          color: #cbd5f5;
          font-size: 13px;
        }

        .user-box {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid rgba(255,255,255,0.1);
        }

        .goal-progress {
          width: 100%;
        }

        .goal-label {
          font-size: 12px;
          color: #94a3b8;
          margin-bottom: 4px;
        }

        .progress-bar {
          width: 100%;
          height: 6px;
          background: rgba(255,255,255,0.1);
          border-radius: 3px;
          overflow: hidden;
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #3b82f6, #8b5cf6);
          border-radius: 3px;
          transition: width 0.3s ease;
        }

        .progress-fill.completed {
          background: linear-gradient(90deg, #22c55e, #16a34a);
        }

        .completion-badge {
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
        }

        .completion-badge.complete {
          background: rgba(34, 197, 94, 0.2);
          color: #22c55e;
        }

        .completion-badge.progress {
          background: rgba(59, 130, 246, 0.2);
          color: #60a5fa;
        }

        .status-badge {
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 500;
        }

        .status-badge.active {
          background: rgba(34, 197, 94, 0.2);
          color: #22c55e;
        }

        .status-badge.expired {
          background: rgba(239, 68, 68, 0.2);
          color: #ef4444;
        }

        .status-badge.completed {
          background: rgba(34, 197, 94, 0.2);
          color: #22c55e;
        }

        .status-badge.inactive {
          background: rgba(148, 163, 184, 0.2);
          color: #94a3b8;
        }

        .history-btn {
          background: rgba(59, 130, 246, 0.15);
          color: #60a5fa;
          border: 1px solid rgba(59, 130, 246, 0.2);
          padding: 6px 14px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
          transition: all 0.3s;
        }

        .history-btn:hover {
          background: rgba(59, 130, 246, 0.25);
          transform: scale(1.02);
        }

        .no-data {
          color: #94a3b8;
          font-size: 12px;
        }

        @media (max-width: 768px) {
          .premium-table-row {
            flex-wrap: wrap;
            gap: 8px;
          }
          
          .premium-table-row > div {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default React.memo(AmbassadorTrackList);